import Api from '@/api'
import dayjs from 'dayjs'

const Event = {
  namespaced: true,
  state: {
    loading: false,
    stepper: 1,
    event_info: {
      user_id: null,
      company_id: null,
      kind: 0,
      participant_ids: [],
      name: '',
      size: '', 
      place: '', 
      zip: '', 
      address: '',     // seria o full addres do evento
      start_at: '', 
      end_at: '', 
      job_start_at: '', 
      job_end_at: '',
      color: '',
      description: '', 

      client_name: '',
      client: {
        client_is: '', // cpf, cnpj
        document: '',
        phone: '',
        email: '',
        corporate_person_name: '', // nome do representante da empresa
        corporate_person_document: '', // 
        client_address: {
          zip : '',
          street : '',
          number : '',
          district : '',
          city : '',
          state : '',
          full_address: '',
        }
      },
      comment: '',
      contract_ok: false, // nao esta utilizando

      value: '', // valor total do evento
      parcels: [
        // {
          //   value: '',
        //   description: '',
        //   date: '',
        //   timestamp
        // }
      ],
      partial_profit: '', // nao esta utilizando

      has_hotel: false, // true or false
      hotel_by: null, // client / company
      hotel_value: null,
      hotel_ok: false, // nao esta utilizando
      has_air_transport: false, // true or false
      air_transport_by: null,
      air_transport_value: null, 
      air_transport_ok: false,

      has_ground_transport: false, // true or false
      ground_transport_by: null,
      ground_transport_value: null,
      ground_transport_ok: false,
      operation_comment: '',
    },
    base_event: {
      user_id: null,
      company_id: null,
      kind: 0,
      name: '',
      status: '',
      category: '',
      value: '',     
      start_at: '',  
      start_time: '', 
      end_at: '',
      end_time: '',
      color: '',
    },
    all_events: null,
    one_event: null
  },
  getters: {
    eventsWithDateMapped: (state) => {
      if(state.all_events != null){
        return state.all_events.map(item => {
          item.start_at = dayjs(item.start_at).format('YYYY-MM-DD hh:mm')
          item.end_at = dayjs(item.end_at).format('YYYY-MM-DD hh:mm')
          return item
        })
      }
    },
    eventParcelsWithDateMapped: (state) => () => {
      if(state.event_info.parcels.length){
        return [...state.event_info.parcels.map(item => {
          let {value, due_date, ...i} = item
          value = (value / 100).toString()
          due_date = dayjs(due_date.replace('0Z', '')).format('YYYY-MM-DD')
          return {value, due_date, ...i}
        })]
      }
    },
  },
  mutations: {
    updateParticipantsIds(state,participant_ids){
      state.event_info.participant_ids = participant_ids
    },
    setLoading(state, val) {
      state.loading = val;
    },
    setEventInfo(state, ev) {
      state.event_info = {...ev};
    },
    setEventMovements(state, mov) {
      state.event_info = {
        ...state.event_info,
        parcels: [...mov]
      }
    },
    setAllEvents(state, ev) {
      state.all_events = [...ev]
    },
    commitEvent(state, ev){
      state.event_info = {...state.event_info, ...ev}
    },
    commitStepper(state, stp){
      state.stepper = stp
    },
    clearAllEvents(state, ev) {
      state.all_events = []
    },
    clearEventInfo(state){
      let event_info = {
        user_id: null,
        company_id: 1,
        kind: 0,
        name: '',
        size: '', 
        place: '', 
        zip: '', 
        address: '', 
        start_at: '', 
        end_at: '', 
        job_start_at: '', 
        job_end_at: '',
        color: '',
        description: '', 
        client_name: '',
        client: {
          client_is: '', 
          document: '',
          phone: '',
          email: '',
          corporate_person_name: '', 
          corporate_person_document: '', 
          client_address: {
            zip : '',
            street : '',
            number : '',
            district : '',
            city : '',
            state : '',
            full_address: '',
          }
        },
        comment: '',
        contract_ok: false,
        value: '',
        parcels: [],
        partial_profit: '',
        has_hotel: false, 
        hotel_by: null,
        hotel_value: null,
        hotel_ok: false, 
        has_air_transport: false,
        air_transport_by: null,
        air_transport_value: null, 
        air_transport_ok: false,
        has_ground_transport: false,
        ground_transport_by: null,
        ground_transport_value: null,
        ground_transport_ok: false,
        operation_comment: '',
      }
      state.event_info = event_info
    }
  },
  actions: {
    // setEvent(context, ev) {
    //   context.commit("setEvent", ev);
    // },
    updateParticipantsIds({commit},participant_ids){
      commit('updateParticipantsIds',participant_ids)
    },
    clearEventInfo({commit}){
      commit('clearEventInfo')
    },
    clearAllEvents({commit}){
      commit('clearAllEvents')
    },
    commitEvent({commit, dispatch}, event){
      commit('commitEvent', event)
    },
    commitStepper({commit, dispatch}, stp){
      commit('commitStepper', stp)
    },

    index({commit, dispatch, rootState}, company_id){
        let notification = {};
        let filter = {
          company_id: company_id
        }
        return Api.Event.index(filter).then(r=>r.data).then(d=> {
          commit('setAllEvents', d)
        }).catch((err) => {
          console.log(err);
        })
    },
    show({commit, dispatch}, id){
      return Api.Event.show(id).then(r=>r.data).then(d=>{
        commit('setLoading', true)
        commit('setEventInfo', d)
        let {id, company_id} = d
        dispatch('getEventMovements', {event_id: id, company_id})
      }).catch(err=>{
        console.log(err);
      }).finally(()=>{
        commit('setLoading', false)
      })
    },
    getEventMovements({commit, dispatch}, filter){
      Api.Movement.indexByEvent(filter).then(r=>r.data).then(d=>{
        commit('setLoading', true)
        commit('setEventMovements', d)
      }).catch(err=>{
        console.log(err);
      }).finally(()=>{
        commit('setLoading', false)
      })
    },
    create({commit, dispatch, rootState}, event){
      let notification = {};
      let event_aux = {
        ...event,
        company_id: rootState.App.activeCompanyId
      }
      return Api.Event.create(event_aux).then(r=>r.data).then(d=> {
        notification.type = 'success';
        notification.msg = 'Realizado com sucesso'
      }).catch((err) => {
        console.log(err);
        notification.type = 'error';
        notification.msg = `Erro: ${err}`
        throw err
      }).finally(()=>{
        dispatch('Notification/add', notification, {root: true});
      })
    },
    update({commit, dispatch}, event){
      let notification = {};
      return Api.Event.update(event).then(r=>r.data).then(d=> {
        notification.type = 'success';
        notification.msg = 'Realizado com sucesso'
        commit('commitEvent', d)
      }).catch((err) => {
        console.log(err);
        notification.type = 'error';
        notification.msg = `Erro: ${err}`
        throw err
      }).finally(()=>{
        dispatch('Notification/add', notification, {root: true});
      })
    },
    delete(){
      let notification = {};
      return Api.Event.delete().then(r=>r.data).then(d=> {
        notification.type = 'success';
        notification.msg = 'Realizado com sucesso'
      }).catch((err) => {
        console.log(err);
        notification.type = 'error';
        notification.msg = `Erro: ${err}`
        throw err
      }).finally(()=>{
        dispatch('Notification/add', notification, {root: true});
      })
    },
  }
};
  
export default Event;